
import React from 'react';
import { Job } from "@/components/jobs/types";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface JobStatusFieldProps {
  job: Pick<Job, 'status'>;
  isEditing: boolean;
  formDataStatus: Job['status'];
  onSelectChange: (name: 'status', value: string) => void;
}

// Added "archived" to the options
const jobStatusOptions: Job['status'][] = ["open", "closed", "on-hold", "filled", "pending", "archived"];

export const JobStatusField: React.FC<JobStatusFieldProps> = ({ job, isEditing, formDataStatus, onSelectChange }) => {
  return (
    <div>
      <Label className="text-xs font-medium text-muted-foreground">Status</Label>
      {isEditing ? (
        <Select
          value={formDataStatus}
          onValueChange={(value) => onSelectChange('status', value as Job['status'])}
        >
          <SelectTrigger className="text-sm">
            <SelectValue placeholder="Select status" />
          </SelectTrigger>
          <SelectContent>
            {jobStatusOptions.map(option => (
              option && <SelectItem key={option} value={option} className="capitalize">
                {option.replace('-', ' ')}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      ) : (
        <p className="capitalize">{job.status ? job.status.replace('-', ' ') : 'N/A'}</p>
      )}
    </div>
  );
};
